import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=09a15e04&scoped=true&"
var script = {}
import style0 from "./HomePage.vue?vue&type=style&index=0&id=09a15e04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a15e04",
  null
  
)

export default component.exports